import React from 'react'
import { AttendanceRuleType } from '../../../../types/AttendanceRuleType'
import { CreateRule } from './CreateRule'
import { EditRule } from './EditRule'
import RulesList from './RulesList'


export default function AttendanceRules() {
    const [showPage, setShowPage] = React.useState('list')
    const [editRule, setEditRule] = React.useState<AttendanceRuleType | null>(null)

    return (
        <>
            {showPage === 'list' && <>
                <div className='min-h-300px'>
                    <RulesList setShowPage={setShowPage} setEditRule={setEditRule} />
                </div>
            </>}
            {showPage === 'create' && <CreateRule setShowPage={setShowPage} />}
            {showPage === 'edit' && !!editRule && <EditRule setShowPage={setShowPage} editRule={editRule} />}
        </>
    )
}